import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_3 = {
  key: 2,
  class: "empty-state"
}
const _hoisted_4 = { key: 3 }
const _hoisted_5 = { key: 0 }

import {
  IonButton,
  IonButtons,
  IonContent,
  IonFab,
  IonFabButton,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonRadio,
  IonRadioGroup,
  IonSearchbar,
  IonSpinner,
  IonTitle,
  IonToolbar,
  modalController
} from '@ionic/vue';
import { closeOutline, saveOutline } from "ionicons/icons";
import { computed, onBeforeMount, ref } from "vue";
import { translate} from '@hotwax/dxp-components'
import { DateTime } from 'luxon' 
import { useStore } from 'vuex'
import { getAvailableTimeZones, hasError } from '../adapter';
import { FacilityService } from '@/services/FacilityService';
import { showToast } from '@/utils';
import logger from '@/logger';

export default /*#__PURE__*/_defineComponent({
  __name: 'FacilityTimeZoneSwitcher',
  props: {
  showBrowserTimeZone: {
    type: Boolean,
    default: true
  },
  showDateTime: {
    type: Boolean,
    default: true
  },
  dateTimeFormat: {
    type: String,
    default: 't ZZZZ'
  }
},
  setup(__props) {

const store = useStore();

const currentFacility = computed(() => store.getters['facility/getCurrent'])
const currentTimeZoneId = computed(() => currentFacility.value?.facilityTimeZone)
const timeZones = ref() as any

const isLoading = ref(true);
const queryString = ref('');
const filteredTimeZones = ref([]) as any
const timeZoneId = ref(currentTimeZoneId.value)
// Fetching timeZone of the browser
const browserTimeZone = ref({
  label: '',
  id: Intl.DateTimeFormat().resolvedOptions().timeZone
})

const props = __props

const closeModal = () => {
  timeZoneId.value = currentTimeZoneId.value;
  modalController.dismiss()
}

onBeforeMount(async () => {
  isLoading.value = true;
  timeZones.value = await getAvailableTimeZones() as any
  timeZoneId.value = currentFacility.value?.facilityTimeZone
  
  if (props.showBrowserTimeZone) {
    browserTimeZone.value.label = ((timeZones.value as any[])?.find((timeZone: any) => (timeZone?.id || '').toLowerCase().includes(browserTimeZone.value.id.toLowerCase()))?.label) || ''
  }

  findTimeZone();
  isLoading.value = false;
})

async function setFacilityTimeZone() {
  try {
  const resp = await FacilityService.updateFacility({
    "facilityId": currentFacility.value.facilityId,
    "facilityTimeZone": timeZoneId.value
  })

  if (!hasError(resp)) {
    await store.dispatch('facility/fetchCurrentFacility', { facilityId: currentFacility.value.facilityId, skipState:true })
    showToast(translate('Facility timezone updated successfully.'))
  } else {
    throw resp.data;
  }
} catch (err) {
  logger.error('Failed to update facility timezone.', err)
  showToast(translate('Failed to update facility timezone.'))
}
  closeModal();
}

function findTimeZone() {
  const searchedString = queryString.value.toLowerCase();
  filteredTimeZones.value = timeZones.value.filter((timeZone: any) => timeZone.id.toLowerCase().match(searchedString) || timeZone.label.toLowerCase().match(searchedString));

  if(props.showBrowserTimeZone) {
    filteredTimeZones.value = filteredTimeZones.value.filter((timeZone: any) => !timeZone.id.toLowerCase().match(browserTimeZone.value.id.toLowerCase()));
  }
}

async function selectSearchBarText(event: any) {
  const element = await event.target.getInputElement()
  element.select();
}

function preventSpecialCharacters($event: any) {
  // Searching special characters fails the API, hence, they must be omitted
  if(/[`!@#$%^&*()_+\-=\\|,.<>?~]/.test($event.key)) $event.preventDefault();
}

function search() {
  isLoading.value = true;
  findTimeZone();
  isLoading.value = false;
}

// clearing the data explicitely as the modal is mounted due to the component being mounted always
function clearSearch() {
  queryString.value = ''
  filteredTimeZones.value = []
  isLoading.value = true
}

const getCurrentTime = (zone: string, format = 't ZZZZ') => {
  return DateTime.now().setZone(zone).toFormat(format)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonHeader), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonButtons), { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonButton), { onClick: closeModal }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      slot: "icon-only",
                      icon: _unref(closeOutline)
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonTitle), null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(translate)("Select time zone")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonSearchbar), {
              onIonFocus: _cache[0] || (_cache[0] = ($event: any) => (selectSearchBarText($event))),
              placeholder: _unref(translate)('Search time zones'),
              modelValue: queryString.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryString).value = $event)),
              onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => {queryString.value = $event.target.value; findTimeZone()}, ["enter"])),
              onKeydown: _cache[3] || (_cache[3] = ($event: any) => (preventSpecialCharacters($event)))
            }, null, 8, ["placeholder", "modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonContent), null, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_unref(IonRadioGroup), {
            modelValue: timeZoneId.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((timeZoneId).value = $event))
          }, {
            default: _withCtx(() => [
              (__props.showBrowserTimeZone)
                ? (_openBlock(), _createBlock(_unref(IonList), { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonListHeader), null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(translate)("Browser time zone")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonItem), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonRadio), {
                            "label-placement": "end",
                            justify: "start",
                            value: browserTimeZone.value.id
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonLabel), null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(browserTimeZone.value.label) + " (" + _toDisplayString(browserTimeZone.value.id) + ") ", 1),
                                  (__props.showDateTime)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(getCurrentTime(browserTimeZone.value.id, __props.dateTimeFormat)), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_unref(IonList), null, {
                default: _withCtx(() => [
                  (__props.showBrowserTimeZone)
                    ? (_openBlock(), _createBlock(_unref(IonListHeader), { key: 0 }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(translate)("Select a different time zone")), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (isLoading.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(_unref(IonItem), { lines: "none" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonSpinner), {
                              color: "secondary",
                              name: "crescent",
                              slot: "start"
                            }),
                            _createTextVNode(" " + _toDisplayString(_unref(translate)("Fetching time zones")), 1)
                          ]),
                          _: 1
                        })
                      ]))
                    : (filteredTimeZones.value.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          _createElementVNode("p", null, _toDisplayString(_unref(translate)("No time zone found")), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredTimeZones.value, (timeZone) => {
                            return (_openBlock(), _createBlock(_unref(IonItem), {
                              key: timeZone.id
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonRadio), {
                                  "label-placement": "end",
                                  justify: "start",
                                  value: timeZone.id
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonLabel), null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(timeZone.label) + " (" + _toDisplayString(timeZone.id) + ") ", 1),
                                        (__props.showDateTime)
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(getCurrentTime(timeZone.id, __props.dateTimeFormat)), 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["value"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createVNode(_unref(IonFab), {
          vertical: "bottom",
          horizontal: "end",
          slot: "fixed"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonFabButton), {
              disabled: !timeZoneId.value || timeZoneId.value === currentTimeZoneId.value,
              onClick: setFacilityTimeZone
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonIcon), { icon: _unref(saveOutline) }, null, 8, ["icon"])
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})